import SummaryAccordion from 'src/components/SummaryAccordion';
import { Box } from '@mui/material';

const ReviewSectionAccordion = ({ title = '', children }) => {
  return (
    <Box sx={{ my: '1rem', textAlign: 'center' }}>
      <SummaryAccordion title={title}>{children}</SummaryAccordion>
    </Box>
  );
};

export default ReviewSectionAccordion;
